const ExperienceView = (data) => {
  console.log(data?.data);
  return (
    <div>
      <h1 className="text-xl mb-4 font-bold">Experience</h1>
      {data?.data?.map((eachExperience, index) => {
        return (
          <div
            key={index}
            className={`grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 bg-neutral-100 p-4 rounded-sm`}
          >
            <div>
              <h3 className="font-semibold text-lg text-gray-900">Company</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachExperience?.companyName || "No Name specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">Address</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachExperience?.companyAddress || "No Address specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">
                Contact Person
              </h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachExperience?.contactPerson || "No contact specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">
                Contact Phone
              </h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachExperience?.contactPhone || "Not specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">Position</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachExperience?.positionHeld || "No position specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">
                Job Description
              </h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachExperience?.jobDescription || "No description specified"}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ExperienceView;
